import React, { Component } from "react";
import "./PullRequests.css";
import { Fade } from "react-reveal";

class PullRequests extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
       
       
      </div>
    );
  }
}

export default PullRequests;
